import { render, staticRenderFns } from "./ClienteIndireto.vue?vue&type=template&id=27799d2a&"
import script from "./ClienteIndireto.vue?vue&type=script&lang=js&"
export * from "./ClienteIndireto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports